module.exports = __webpack_public_path__ + "static/media/background.dc3a725e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/background.jpg
// module id = 316
// module chunks = 0